import { ReactNode } from 'react'

import { Stack, StackProps, Box, Typography, TypographyProps } from '@mui/material'
import { BlockCaption } from './blockCaption'

export type SectionProps = {
  label?: string
  showLabel?: boolean
  children?: ReactNode
  disablePadding?: boolean
  disablePaddingX?: boolean
  disablePaddingY?: boolean
  disablePaddingTop?: boolean
  labelWidth?: string
  labelProps?: StackProps
  labelVariant?: TypographyProps["variant"]
  innerProps?: StackProps
} & StackProps

export const Section = ({
  label,
  showLabel,
  children,
  disablePadding,
  disablePaddingX,
  disablePaddingY,
  disablePaddingTop,
  labelWidth: minWidth,
  labelProps,
  labelVariant,
  innerProps,
  ...others
}: SectionProps) => (
  <Stack
    direction="row"
    width="100%"
    spacing={disablePadding || disablePaddingX ? 0 : 1}
    {...others}
  >
    {showLabel === false ? <></> : (
      <Stack
        direction="column"
        width={minWidth || '7em'}
        textAlign="right"
        paddingY={label ? 1 : 0}
        paddingRight={2}
        borderRight={1}
        borderColor="divider"
        flexShrink={0}
        {...labelProps}
      >
        {label && (
          <Typography variant={labelVariant ?? "body2"} color="text.primary" whiteSpace="pre-wrap">
            {label}
          </Typography>
        )}
      </Stack>
    )}
    <Stack
      flexGrow={1}
      position="relative"
      boxSizing="border-box"
      width="100%"
      direction="column"
      justifyContent="center"
      spacing={disablePadding ? 0 : 0.5}
      paddingX={
        (!children || disablePadding || disablePaddingX) ? 0 : 1
      }
      paddingTop={
        (!children || disablePadding || disablePaddingY || disablePaddingTop) ? 0 : 1
      }
      paddingBottom={
        (!children || disablePadding || disablePaddingY) ? 0 : 1
      }
      overflow="hidden"
      {...innerProps}
    >
      {children}
    </Stack>
  </Stack>
)

type SectionBlockProps = {
  isSmallMedia: boolean
} & SectionProps
export const SectionBlock = ({
  isSmallMedia,
  ...others
}: SectionBlockProps) => {
  return isSmallMedia ? (
    <Box>
      <BlockCaption caption={others.label ?? ''}/>
      <Box sx={others.disablePadding ? undefined : { paddingX: 1, paddingY: 0.5 }}>
        {others.children}
      </Box>
    </Box>
  ) : (
    <Section {...others}/>
  )
}
